import { Route, Routes, useSearchParams } from "react-router-dom";
import EmailVerification from "./verification/EmailVerification";
import { GlobalContext } from "./GlobalContext";
import { useEffect, useState } from "react";
import LoginPage from "./LoginPage";
import ChangePassword from "./ChangePassword";
import Test from "./Test";

function App() {
  const [params] = useSearchParams();
  const [hl, setHl] = useState(params.get("hl"));

  // useEffect(() => {
  //   setHl(params.get("hl"));
  // }, []);

  return (
    <GlobalContext.Provider value={{ hl, setHl }}>
      <div style={{ width: "100%", height: "100vh" }}>
        <Routes>
          <Route path="/verification/email" Component={EmailVerification}/>
          <Route path="/:app/verification/email" Component={EmailVerification}/>
          <Route path="/login" Component={LoginPage}/>
          <Route path="/change-password/email" Component={ChangePassword}/>
          <Route path="/test" Component={Test}/>
        </Routes>
      </div>
    </GlobalContext.Provider>
  );
}

export default App;
